/**
* Data model that represents an OAuth
*
* @class OAuthModel
*/
var OAuthModel = function ( data ) {
	var self; // Convenience reference so the context of 'this' becomes clearer

	// Predicate this data model on the AbstractDataModel.
	// This establishes core functionality required of DataModels,
	// which can be overwritten by methods below.
	// Specifically, conversion of XML data to JSON
	AbstractDataModel.apply( this, arguments );

	self = this;

	self.providerId	= ko.observable( null );
	self.status		= ko.observable( 'active' );


	/**
	* Returns CSS class names to the UI
	*
	* @method css
	* @return {String}
	*/
	self.css = ko.computed( function () {
		var aClasses = [];

		aClasses.push( 'authicon-' + ( ( self.providerId() == 2 ) ? 'outlook' : 'google' ) );

		aClasses.push( 'oauth-status-'+ self.status().toLowerCase() );

		if ( self.id == qcal.oauthWS.oAuthSel() ) {
			aClasses.push( 'highlight' );
		}

		return aClasses.join(' ');
	});


	/**
	* Returns a string indicating the action state of a link
	*
	* @method toggleLabel
	* @return {String}
	*/
	self.toggleLabel = ko.computed( function () {
		/// TODO - replace with localizations
		return ( self.status().toLowerCase() == 'active' ) ? qcal.messagesWS.get('disable') : qcal.messagesWS.get('enable');
	});


	/**
	* If the model was initialized with a data parameter,
	* call the loadData method to populate the observed variables.
	*/
	if ( data ) {

		for ( var prop in data ) {
			if ( data.hasOwnProperty( prop ) ) {

				switch ( prop ) {
					case 'status':
						self.status( data[prop] );
						break;

					case 'providerId':
						self.providerId( data[prop] );
						break;

					default:
						self[prop] = data[prop];
						break;
				}
			}
		}
	}

	// Return self (OAuthModel) to be chainable, for best practice
	return self;
};

OAuthModel.prototype = AbstractDataModel.prototype;
OAuthModel.prototype.constructor = OAuthModel;